/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Faqs_DescriptionInputs */

const en_dashboard_faqs_description = /** @type {(inputs: Dashboard_Faqs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access to frequently asked questions (FAQs) to help you understand your insurance coverage. Read ‘How to Guides’ to navigate your policy better.`)
};

const fr_dashboard_faqs_description = /** @type {(inputs: Dashboard_Faqs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès aux questions fréquemment posées (FAQ) pour vous aider à comprendre votre couverture d'assurance. Lisez les 'Guides pratiques' pour mieux naviguer dans votre police.`)
};

/**
* | output |
* | --- |
* | "Access to frequently asked questions (FAQs) to help you understand your insurance coverage. Read ‘How to Guides’ to navigate your policy better." |
*
* @param {Dashboard_Faqs_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const dashboard_faqs_description = /** @type {((inputs?: Dashboard_Faqs_DescriptionInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Faqs_DescriptionInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_faqs_description(inputs)
	return fr_dashboard_faqs_description(inputs)
});